export default "__VITE_ASSET__BRyjGk$c__"